var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightCornerBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 116,
    viewBox: "0 0 229 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.754 57.9918L229 57.9918L229 115.984L171.754 115.984L171.754 57.9918Z",
    fill: "#CC5E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.492 -1.02229e-05L171.754 0L171.754 57.9918L114.492 -1.02229e-05Z",
    fill: "#992C21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.492 57.9918L171.754 57.9918L171.754 116L114.492 57.9918Z",
    fill: "#2161AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.492 116L57.2461 116L57.2461 57.9918L114.492 116Z",
    fill: "#9E7E2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.754 0L171.754 57.9918L114.492 57.9918L171.754 0Z",
    fill: "#BD3728"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.67029e-05 -1.02201e-05L57.2458 0L57.2458 57.9918L-2.67029e-05 -1.02201e-05Z",
    fill: "#377FC0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4571 -6.38934e-06L57.2458 0L57.2458 36.2551L21.4571 -6.38934e-06Z",
    fill: "#0C4D91"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2461 -1.02201e-05L114.492 0L114.492 57.9918L57.2461 -1.02201e-05Z",
    fill: "#70C8BB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2461 57.9918L114.492 57.9918L114.492 116L57.2461 57.9918Z",
    fill: "#C59A2D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2945 -1.02114e-05C72.4687 0.0130085 87.017 6.12859 97.7422 17.0027C108.467 27.8769 114.492 42.6199 114.492 57.9918L57.2945 57.9918L57.2945 -1.02114e-05Z",
    fill: "#06B395"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2948 21.7519C66.7823 21.7519 75.8812 25.5699 82.5898 32.366C89.2985 39.1621 93.0674 48.3796 93.0674 57.9907L57.2948 57.9907L57.2948 21.7519Z",
    fill: "#049078"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.123 29.0041L114.492 -5.11147e-06L114.492 57.9918L143.123 29.0041Z",
    fill: "#CC5D4D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.754 -1.02201e-05L229 0L229 57.9918L171.754 57.9918L171.754 -1.02201e-05Z",
    fill: "#2161AC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M214.685 24.1743C209.411 24.1743 205.136 19.8434 205.136 14.5009C205.136 9.15835 209.411 4.82739 214.685 4.82739C219.958 4.82739 224.234 9.15836 224.234 14.5009C224.234 19.8434 219.958 24.1743 214.685 24.1743Z",
    fill: "#377FC0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.685 53.1791C209.411 53.1791 205.136 48.8481 205.136 43.5056C205.136 38.1631 209.411 33.8322 214.685 33.8322C219.959 33.8322 224.234 38.1631 224.234 43.5056C224.234 48.8481 219.959 53.1791 214.685 53.1791Z",
    fill: "#E6EDF8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.053 24.1743C180.78 24.1743 176.504 19.8434 176.504 14.5009C176.504 9.15835 180.78 4.82739 186.053 4.82739C191.327 4.82739 195.603 9.15836 195.603 14.5009C195.603 19.8434 191.327 24.1743 186.053 24.1743Z",
    fill: "#E6EDF8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M186.053 53.1791C180.78 53.1791 176.504 48.8481 176.504 43.5056C176.504 38.1631 180.78 33.8322 186.053 33.8322C191.327 33.8322 195.603 38.1631 195.603 43.5056C195.603 48.8481 191.327 53.1791 186.053 53.1791Z",
    fill: "#377FC0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M200.369 116C184.556 116 171.738 103.014 171.738 86.9959C171.738 70.9774 184.556 57.9918 200.369 57.9918C216.181 57.9918 229 70.9774 229 86.9959C229 103.014 216.181 116 200.369 116Z",
    fill: "#F27544"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M200.369 101.497C192.463 101.497 186.054 95.0047 186.054 86.9954C186.054 78.9862 192.463 72.4934 200.369 72.4934C208.276 72.4934 214.685 78.9862 214.685 86.9954C214.685 95.0047 208.276 101.497 200.369 101.497Z",
    fill: "#F9AB8B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M138.356 57.9918L171.754 91.8244L171.754 116L114.492 57.9918L138.356 57.9918Z",
    fill: "#0C4D91"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M147.889 116L114.492 82.1673L114.492 57.9918L171.754 116L147.889 116Z",
    fill: "#2161AC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114.492 116L114.492 82.1671L147.89 116L114.492 116Z",
    fill: "#0C4D91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCornerBg);
export default __webpack_public_path__ + "static/media/right_corner_bg.34a8ba185334d614840fea3c69bffb98.svg";
export { ForwardRef as ReactComponent };